import * as Yup from 'yup';

import { Strings } from '@app/constants';

// ----------------Add Project----------------
export const addProjectSchema = Yup.object()
  .shape({
    projectName: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.projectName)),
    client: Yup.string().required(Strings.validation.selectRequired(Strings.field.client)),
    startDate: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.startDate)),
    estimatedEndDate: Yup.string().required(
      Strings.validation.fieldRequired(Strings.field.estimatedEndDate)
    ),
    priority: Yup.string().required(Strings.validation.selectRequired(Strings.field.priority)),
    managers: Yup.array()
      .of(
        Yup.object({
          id: Yup.number().required(),
          name: Yup.string().required(),
        })
      )
      .test('manager', Strings.validation.selectRequired(Strings.field.manager), function (value) {
        return value && value.length > 0;
      }),
    members: Yup.array()
      .of(Yup.number())
      .test('member', Strings.validation.selectRequired(Strings.field.member), function (value) {
        return value && value.length > 0;
      }),
    description: Yup.string()
      .trim()
      .required(Strings.validation.fieldRequired(Strings.field.description)),
  })
  .required();
